import React, { useState, useEffect } from "react";
import { Table, Container, Input, Row, Col, Button } from 'reactstrap';
import './ProposalStyle.css';
import "./Reports.css";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report59Component() {
    const [loading, setLoading] = useState(false);
    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [othYearSelected, setOThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [Re59data, setRe59data] = useState([]);

    pdfMake.fonts = {
        THSarabunNew: {
            normal: 'THSarabunNew.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNewn BoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf'
        }
    }

    async function getR59() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        formData.append("othYear", othYearSelected);
        const res59 = await fetch("/api/Support/getR59", {
            method: 'POST',
            body: formData
        })
        const Re59data = await res59.json()
        setRe59data(Re59data.dataenum);
        // console.log(Re59data)
    }

    const [Re59yeardata, setRe59yeardata] = React.useState([]);

    async function getR59year() {
        const res = await fetch("/api/Support/getyear59")
        const Re59yeardata = await res.json()
        setRe59yeardata(Re59yeardata.dataenum)
        // console.log(Re59yeardata)
    }


    const y2 = Re59yeardata.filter(n => n.yearTh >= othYearSelected);

    React.useEffect(() => {
        getR59()
        getR59year()
    }, [thYearSelected, othYearSelected]);








    return (
        <Container>
            <div>

                <Row className="mb-3 align-items-center">
                    <Col md={2}><h5>ปีงบประมาณ</h5></Col>

                    <Col md={3}>
                        <Input
                            id="othYear"
                            name="othYear"
                            type="select"
                            value={othYearSelected}
                            onChange={(e) => {
                                setOThYearSelected(e.target.value)
                            }}
                        >
                            {Re59yeardata.map((item, i) => (
                                <option value={item.yearTh}>
                                    {item.yearTh}
                                </option>

                            ))}
                        </Input>
                    </Col>

                    <Col md={1} className="text-center">ถึง</Col>

                    <Col md={3}>
                        <Input
                            type="select"
                            id="thYear"
                            name="thYear"
                            value={thYearSelected}
                            onChange={(e) => {
                                setThYearSelected(e.target.value)
                            }}
                        >
                            {y2.map((item, i) => (
                                <option value={item.yearTh}>
                                    {item.yearTh}
                                </option>

                            ))}
                        </Input>
                    </Col>

                    <Col md={3} className="text-end">
                        <Button
                            className="btn-export excel me-2"
                            href={`api/Support/xlsxR59?thYear=${thYearSelected}&othYear=${othYearSelected}`}
                        // disabled={loading || !reportData.length}
                        >
                            Excel
                        </Button>
                        <Button
                            className="btn-export pdf"
                            href={`api/Support/pdfR59?thYear=${thYearSelected}&othYear=${othYearSelected}`}
                        // disabled={loading || !reportData.length}
                        >
                            PDF
                        </Button>
                    </Col>
                </Row>
                <Table bordered
                    hover
                    responsive
                    className="report-table"
                    style={{
                        minWidth: "1000px",
                    }}>
                    <thead>
                        <tr>
                            <th rowSpan="3">
                                ที่
                            </th>
                            <th rowSpan="3" className='text-center'>
                                รายการ
                            </th>
                            <th rowSpan="3" className=' text-center'>
                                จำนวนผู้เข้ารับการประเมิน (คน)
                            </th>
                            <th rowSpan="3" className=' text-center'>
                                จำนวนผู้ผ่านการประเมิน (คน)
                            </th>
                            <th colSpan="15" className=' text-center'>
                                จำนวนเงินช่วยเหลือหรืออุดหนุน
                            </th>
                        </tr>
                        <tr>
                            <th colSpan="1" className='text-center'>
                                ค่าตอบแทนผู้ประเมิน (บาท)
                            </th>
                            <th colSpan="1" className='text-center'>
                                ค่าตอบการปฏิบัติงานนอกเวลาราชการ (บาท)
                            </th>
                            <th colSpan="1" className='text-center'>
                                ค่าเดินทางไปราชการทำหน้าที่ผู้ประเมิน (บาท)
                            </th>
                            <th colSpan="1" className='text-center'>
                                ค่าวัสดุใช้ในการประเมิน (บาท)
                            </th>
                            <th colSpan="1" className='text-center'>
                                รวม (บาท)
                            </th>

                        </tr>



                    </thead>

                    <tbody>
                        {Re59data.length > 0 && Re59data.map((item, i) => (
                            <tr >
                                <td className='text-center'>
                                    {i + 1}
                                </td>
                                <td className='text-start'>
                                    {item.list}
                                </td>
                                <td className='text-end'>
                                    {item.personTest}
                                </td>
                                <td className='text-end'>
                                    {item.passEvaluation}
                                </td>
                                <td className='text-end'>
                                    {item.evaluatorExpense}
                                </td>
                                <td className='text-end'>
                                    {item.compensationExpense}
                                </td>

                                <td className='text-end'>
                                    {item.travellingExpense}
                                </td>
                                <td className='text-end'>
                                    {item.materialExpense}
                                </td>
                                <td className='text-end'>
                                    {item.sum}
                                </td>

                            </tr>

                        )) || <tr><td colSpan="9" rowSpan="6" className='text-center'>No Data</td></tr>}

                    </tbody>



                </Table>
            </div>

        </Container>


    )
}